import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettlementReceivedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 7,
	viewBox: "0 0 17 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.9912 2.8C4.52835 1.55556 6.52248 0.777778 8.72434 0.777778C12.588 0.777778 15.8534 3.13444 17 6.39333L15.0391 7C14.6017 5.75542 13.7558 4.67185 12.6219 3.90372C11.488 3.13559 10.124 2.72211 8.72434 2.72222C7.1041 2.72222 5.62512 3.28222 4.47018 4.18444L7.47801 7H0V0L2.9912 2.8Z",
		fill: "#4A9167"
	})
});
export default SvgSettlementReceivedIcon;
